import React, { useContext } from 'react';
import { appContext } from '../../App';
import { lang } from '../../util/constants';

import './financial-help.css';

const FinancialHelp = () => {
   
   const { language } = useContext(appContext);

   const heading = language === lang.pt ? 'Se você preferir nos ajudar financeiramente segue abaixo a conta para depósito' : 'If you prefer to help us financially';

   const theContent = language === lang.pt ? ptContent : enContent;
   
   return (
      <div className='fh-container padd d-flex flex-column align-items-center'>
         <h3 className='text-center'>{heading}</h3><br></br>
         <div className='fh'>
            {
               theContent.map(content => {
                  return (
                     <div className='d-flex justify-content-between'>
                        <div className='fh-item fh-item-1'>{content.info}</div>
                        <div className='fh-item fh-item-2 text-center'>{content.data}</div>
                     </div>
                  )
               })
            }
         </div>
      </div>
   )
}

const ptContent = [
   {
      info: 'Nome',
      data: 'Mauro Lima'
   },
   {
      info: 'CPF',
      data: '223.480.181-87'
   },
   {
      info: 'Banco',
      data: 'Banco do Brasil'
   },
   {
      info: 'CC',
      data: '48221-8'
   },
   {
      info: 'Agência',
      data: '5190-x'
   }
];

const enContent = [
   {
      info: 'E-transfer',
      data: 'kalytalima.cad@gmail.com'
   }
]

export default FinancialHelp
